export enum FilterHearingOptions {
  RASCUNHO_OITIVA = 'RASCUNHO',
  OITIVA_FINALIZADA = 'FINALIZADO',
  OITIVA_EXCUIDA = 'EXCLUIDO',
}
